import { render, staticRenderFns } from "./FlightDetailsForm.vue?vue&type=template&id=b5efd9f4&scoped=true&"
import script from "./FlightDetailsForm.vue?vue&type=script&lang=js&"
export * from "./FlightDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./FlightDetailsForm.vue?vue&type=style&index=0&id=b5efd9f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5efd9f4",
  null
  
)

export default component.exports